import { CommonModule } from '@angular/common';
import { Component, OnInit, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { LoadingSkeletonComponent } from '@components';
import { ContentService, GknFundamentalCardLink } from '@services';
import { Observable } from 'rxjs';
import { HomeFundamentalsCardComponent } from '../home-fundamentals-card/home-fundamentals-card.component';
import { HomeFundamentalsCardType } from '../home-fundamentals-card/home-fundamentals-card.enum';

@Component({
    selector: 'app-home-fundamentals-product-ideas-lab',
    templateUrl: './home-fundamentals-product-ideas-lab.component.html',
    styleUrls: ['./home-fundamentals-product-ideas-lab.component.scss'],
    imports: [
        CommonModule,
        HomeFundamentalsCardComponent,
        LoadingSkeletonComponent,
        MatButtonModule,
        MatIconModule,
        MatTooltipModule,
    ],
})
export class HomeFundamentalsProductIdeasLabComponent implements OnInit {
    private contentService = inject(ContentService);

    cardType = HomeFundamentalsCardType.PRODUCT_IDEAS_LAB;
    productIdeasLab$: Observable<{ links: GknFundamentalCardLink[]; action: GknFundamentalCardLink }>;

    ngOnInit(): void {
        this.productIdeasLab$ = this.contentService.productIdeasLab$;
    }
}
